(() => {
  'use strict';
  if (window.__damaChatGPTAds) return;
  const loader = document.getElementById('dama-chatgpt-ads-loader');
  if (!loader || loader.dataset.excluded === 'true') return;
  const pixelId = loader.dataset.pixelId;
  if (!pixelId) return;
  const hosts = new Set(['damacouture.com', 'damacouture.de', 'damacouture.pl', 'damacouture.co.uk', 'damacouture.it', 'damacouture.fr', 'damacouture.es']);
  const host = window.location.hostname.toLowerCase().replace(/^www\./, '');
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const body = document.body;
  const role = body?.dataset.damaThemeRole || window.Shopify?.theme?.role;
  const excludedQuery = ['preview_theme_id', 'preview_script_id', 'shopify-pixel-mode', 'q', 'query', 'search', 'search_term', 'email', 'phone', 'address'];
  const excludedPath = /\/(?:account|checkouts?|orders|cart|search|password)(?:\/|$)|\/pages\/(?:partner-werden|become-a-partner|become-a-retailer|become-retailer|wspolpraca|devenir-partenaire|wholesale|b2b)(?:\/|$)/i;
  if (!hosts.has(host) || !window.Shopify || window.Shopify.designMode || window.Shopify.inspectMode ||
      (role && role !== 'main') || body?.classList.contains('b2b') || excludedPath.test(path) ||
      excludedQuery.some(key => params.has(key)) || document.getElementById('preview-bar-iframe') ||
      document.getElementById('OnlineStorePreviewBarNextData')) return;
  if (document.cookie.split(';').some(value => value.trim() === 'dama_internal_browser=1')) return;
  const allowedPage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages)\/[a-z0-9-]+(?:\/products\/[a-z0-9-]+)?|blogs\/[a-z0-9-]+(?:\/[a-z0-9-]+)?)?\/?$/i.test(path);
  if (!allowedPage) return;
  let initialized = false, ready = false, loading = false, failed = false;
  let blockedByDenial = false, lastConsentCommand = null;
  let sequence = 0, requestCount = 0;
  const sentViews = new Set();
  const viewIds = new Map();
  const seenClicks = new WeakSet();
  const clickTimes = new WeakMap();
  let ownQueue;
  const state = { status: () => ({ initialized, ready, consentChoice: choice(), lastConsentCommand, loading, failed, requestCount }) };
  window.__damaChatGPTAds = Object.freeze(state);
  function mark(status) {
    loader.dataset.damaAdsStatus = status;
    loader.dataset.damaAdsConsentChoice = choice();
    loader.dataset.damaAdsRequestCount = String(requestCount);
  }
  function choice() {
    try {
      const value = window.Shopify.customerPrivacy?.currentVisitorConsent?.();
      if (!value || !['', 'yes', 'no'].includes(value.marketing)) return 'pending';
      if (value.marketing === 'no' || value.sale_of_data === 'no') return 'denied';
      return value.marketing === 'yes' ? 'granted' : 'unknown';
    } catch (_) { return 'pending'; }
  }
  function allowed() {
    const current = choice();
    return (current === 'unknown' && !blockedByDenial) || current === 'granted';
  }
  function eventId() {
    return 'dama_' + (window.crypto?.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '_' + (++sequence).toString(36));
  }
  function productContents() {
    const id = loader.dataset.productId || '';
    return /^\d{1,20}$/.test(id) ? [{ id, content_type: 'product' }] : [];
  }
  function measure(name, custom, contents, id) {
    if (!ready || !allowed()) return false;
    const data = { type: custom ? 'custom' : 'contents' };
    if (contents?.length) data.contents = contents;
    const options = { event_id: id || eventId(), opt_out: true };
    if (custom) options.custom_event_name = name;
    try {
      window.oaiq('measure', custom ? 'custom' : name, data, options);
      requestCount++;
      mark('ready');
      return true;
    }
    catch (_) { return false; }
  }
  function finderPage() {
    if (document.querySelector('.dama-store-finder, [data-finder-list]')) return true;
    try {
      const target = new URL(body.dataset.damaFinderUrl || '/pages/store-finder', window.location.origin);
      return target.pathname.replace(/\/$/, '') === path.replace(/\/$/, '');
    } catch (_) { return false; }
  }
  function views() {
    const phase = choice();
    function view(key, name, custom, contents) {
      if (sentViews.has(key + ':' + phase)) return;
      if (!viewIds.has(key)) viewIds.set(key, eventId());
      if (measure(name, custom, contents, viewIds.get(key))) sentViews.add(key + ':' + phase);
    }
    const pageContents = [{ id: host + path, content_type: 'page' }];
    view('page', 'page_viewed', false, pageContents);
    const product = productContents();
    if (body.dataset.damaPageType === 'product' && product.length) view('product', 'contents_viewed', false, product);
    if (finderPage()) view('finder', 'dama_finder_opened', true, pageContents);
  }
  function start() {
    if (initialized || loading || failed || !allowed()) return;
    if (typeof window.oaiq !== 'undefined') { failed = true; mark('failed'); return; }
    const queue = function () { queue.q.push(arguments); };
    queue.q = [];
    ownQueue = queue;
    window.oaiq = queue;
    if (choice() === 'granted') { queue('consent', true); lastConsentCommand = true; }
    queue('init', { pixelId });
    initialized = true;
    loading = true;
    mark('loading');
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    script.onload = () => { loading = false; ready = true; sync(); };
    script.onerror = () => {
      loading = false;
      failed = true;
      if (window.oaiq === ownQueue) ownQueue.q = [];
      mark('failed');
    };
    document.head.appendChild(script);
  }
  function sync() {
    if (failed) { mark('failed'); return; }
    const current = choice();
    if (current === 'pending') { mark('pending'); return; }
    if (current === 'denied') {
      blockedByDenial = true;
      if (initialized && lastConsentCommand !== false) {
        window.oaiq('consent', false);
        lastConsentCommand = false;
      }
      mark('blocked');
      return;
    }
    if (current === 'granted') blockedByDenial = false;
    if (!allowed()) { mark('blocked'); return; }
    start();
    if (initialized && current === 'granted' && lastConsentCommand !== true) {
      window.oaiq('consent', true);
      lastConsentCommand = true;
    }
    if (!ready) return;
    mark('ready');
    views();
  }
  function contactType(link) {
    const raw = (link.getAttribute('href') || '').trim();
    if (/^tel:\+?[\d\s().-]{6,25}$/i.test(raw)) return 'salon_phone_click';
    let target;
    try { target = new URL(raw, window.location.href); } catch (_) { return ''; }
    if (!/^https?:$/.test(target.protocol)) return '';
    const targetHost = target.hostname.toLowerCase().replace(/^www\./, '');
    const map = targetHost === 'maps.app.goo.gl' || /^maps\.google\.[a-z.]+$/i.test(targetHost) ||
      (targetHost === 'goo.gl' && /^\/maps(?:\/|$)/i.test(target.pathname)) ||
      (/^(?:www\.)?google\.[a-z.]+$/i.test(targetHost) && /^\/maps(?:\/|$)/i.test(target.pathname)) ||
      (targetHost === 'maps.apple.com');
    if (map) return 'salon_map_click';
    if (link.closest('.stores__bubble-buttons') || hosts.has(targetHost) || targetHost.endsWith('.myshopify.com') ||
        /(^|\.)(?:facebook\.com|instagram\.com|pinterest\.[a-z.]+|youtube\.com|google\.[a-z.]+|shopify\.com)$/.test(targetHost)) return '';
    return 'salon_site_click';
  }
  document.addEventListener('click', event => {
    if (!allowed() || !ready || seenClicks.has(event)) return;
    const target = event.target?.closest ? event.target : event.target?.parentElement;
    if (!target?.closest) return;
    const link = target.closest('a[href]');
    if (!link) return;
    let name;
    if (link.matches('a[data-availability-cta], a.av-ready, a[href="#product-availability"]')) {
      name = 'check_boutique_availability';
    } else if (link.closest('.product-availability__item, #product-availability, [data-finder-list] .stores__list-item, .stores__bubble, .dama-local .lokal__salon')) {
      name = contactType(link);
    }
    if (!name) return;
    const now = Date.now();
    const previous = clickTimes.get(link);
    if (previous && previous.name === name && now - previous.at < 750) return;
    seenClicks.add(event);
    let contents = productContents();
    const salon = link.closest('[data-dama-salon-id]')?.dataset.damaSalonId;
    if (/^salon_[a-f0-9]{16}$/.test(salon || '')) contents = [{ id: salon, content_type: 'retailer' }];
    if (measure(name, true, contents)) clickTimes.set(link, { name, at: now });
  }, true);
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('dama:analytics-consent', sync);
  document.addEventListener('dama:tracking-ready', sync);
  sync();
})();
